import { render } from "./sdgdcgbdDetail.vue?vue&type=template&id=ab7b7126&scoped=true&ts=true"
import script from "./sdgdcgbdDetail.vue?vue&type=script&lang=ts"
export * from "./sdgdcgbdDetail.vue?vue&type=script&lang=ts"

import "./sdgdcgbdDetail.vue?vue&type=style&index=0&id=ab7b7126&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab7b7126"]])

export default __exports__